// src/pages/Home.tsx
import React from 'react';
import { Paper } from '@mui/material';
import { Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import Usuarios from './Usuarios';
import Productos from './Productos';
import Instaladores from './Instaladores';
import TipoIdentificacion from './TipoIdentificacion';
import Clientes from './Clientes';
import Unidades from './Unidades';
import Precios from './Precios';
import Categorias from './Categorias';
import { useAuth } from '../../context/auth';
import { AccessDenied } from '../../components/AccessDenied/Index';

const Home: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { permisos } = useAuth();
  const { Prm_Config, Prm_Config_Usr_Ver, Prm_Config_Instal_Ver, Prm_Config_Tip_Id_Ver, Prm_Config_Cltes_Ver, Prm_Config_Prod_Ver, Prm_Config_Categ_Ver, Prm_Config_Unid_Ver } = permisos;

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  if (Prm_Config === 0) {
    return <AccessDenied />;
  }

  return (
    <Paper sx={{ p: { xs: 2, sm: 3 }, minHeight: 'calc(100vh - 140px)', marginBottom: 4, overflow: 'auto', borderRadius: '26px' }}>
      <h4 style={{ margin: '0 0 14px', fontSize: '1.15rem', fontWeight: 800, letterSpacing: '-0.02em' }}>Configuracion</h4>

      <Tabs value={activeTab} onChange={handleTabChange} scrollButtons='auto' variant='scrollable'>
        {Prm_Config_Usr_Ver === 1 && <Tab label='Usuarios' />}
        {Prm_Config_Instal_Ver === 1 && <Tab label='Instaladores' />}
        {Prm_Config_Tip_Id_Ver === 1 && <Tab label='Tipos Identificacion' />}
        {Prm_Config_Cltes_Ver === 1 && <Tab label='Clientes' />}
        {Prm_Config_Prod_Ver === 1 && <Tab label='Productos' />}
        {Prm_Config_Categ_Ver === 1 && <Tab label='Categorias' />}
        {Prm_Config_Unid_Ver === 1 && <Tab label='Unidades' />}
        {Prm_Config_Unid_Ver === 1 && <Tab label='Listas de Precios' />}
      </Tabs>
      {activeTab === 0 && <Usuarios />}
      {activeTab === 1 && <Instaladores />}
      {activeTab === 2 && <TipoIdentificacion />}
      {activeTab === 3 && <Clientes />}
      {activeTab === 4 && <Productos />}
      {activeTab === 5 && <Categorias />}
      {activeTab === 6 && <Unidades />}
      {activeTab === 7 && <Precios />}
    </Paper>
  );
};

export default Home;
